import { render, staticRenderFns } from "./Expectative.vue?vue&type=template&id=33096a24&scoped=true"
import script from "./Expectative.vue?vue&type=script&lang=js"
export * from "./Expectative.vue?vue&type=script&lang=js"
import style0 from "./Expectative.vue?vue&type=style&index=0&id=33096a24&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33096a24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33096a24')) {
      api.createRecord('33096a24', component.options)
    } else {
      api.reload('33096a24', component.options)
    }
    module.hot.accept("./Expectative.vue?vue&type=template&id=33096a24&scoped=true", function () {
      api.rerender('33096a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/rubric/form/components/questionTypes/Expectative.vue"
export default component.exports